import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getData,
  postData,
} from "../../../CommonElements/Functions/PostGetFun";
import { API } from "../../../api/API";
import moment from "moment";
import CommonTableNew from "../../Tables/ReactstrapTables/BasicTables/Common/CommonTableNew";
import CardHeaderSpan from "../../../Utils/CommonComponents/CardHeaderSpan";
import { Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";
import { toast } from "react-toastify";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Card,
  CardBody,
} from "reactstrap";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { isOwnRequest } from "../../../Utils/authUtils";
import { getLabel } from "../../../sharedFunctions/CommonLable";

const isSubmittableMonth = (selectedMonth: string) => {
  if (!selectedMonth) return false;
  const rawDate = selectedMonth.split("|")[0];
  let mDate = moment(rawDate, "YYYY-MM-DD");
  if (!mDate.isValid()) {
    mDate = moment(rawDate, "MM-YYYY");
  }
  if (!mDate.isValid()) return false;
  const validationMonth = mDate.clone().add(1, "month").startOf("month").format("YYYY-MM-DD");
  const currentMonth = moment().startOf("month").format("YYYY-MM-DD");
  return moment(currentMonth).diff(moment(validationMonth)) >= 0;
};

const Expenses: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { month, employeeId, dropdownLabel, totalExpenseAmount, backPath, backState } =
    location.state || {};
  console.log(
    month,
    employeeId,
    dropdownLabel,
    totalExpenseAmount,
    "=========params"
  );

  const [expenseData, setExpenseData] = useState<any[]>([]);
  const [statusMap, setStatusMap] = useState<Record<number, string>>({});
  const [loading, setLoading] = useState<boolean>(true); // Added loading state
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState<Record<number, boolean>>({});
  const [toBeVerifiedExpenses, setToBeVerifiedExpenses] = useState<any[]>([]);
  const [expIdList, setExpIdList] = useState<string>("");
  const [varifiedExpenses, setVarifiedExpenses] = useState<
    Record<string, string[]>
  >({});
  const [workingDays, setWorkingDays] = useState<number | null>(null);
  const [totalExpCount, setTotalExpCount] = useState(0);
  const [totalExpenseAmountFromApi, setTotalExpenseAmountFromApi] =
    useState<number>(0);
  const [submitConfirmationVisible, setSubmitConfirmationVisible] = useState(false);
  const [submitRemarkModalVisible, setSubmitRemarkModalVisible] = useState(false);
  const [submitRemark, setSubmitRemark] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [refreshKey, setRefreshKey] = useState(false);

  const [selectedExpIds, setSelectedExpIds] = useState<string[]>([]);

  const [lastDates, setLastDates] = useState({
    LastSubmittedDate: null,
    LastApprovedDate: null,
    LastAuditedDate: null,
  });

  const serverUrl = localStorage.getItem("serverUrl");
  const userEmp =
    localStorage.getItem("empId") ||
    localStorage.getItem("employeeId") ||
    localStorage.getItem("userId") ||
    "";

  const selectedMonthStr = useMemo(() => {
    return typeof month === "object" && month !== null
      ? Object.keys(month)[0]
      : typeof month === "string"
      ? month
      : "";
  }, [month]);

  const activeEmpId = employeeId ?? userEmp;

  const isManagerView = useMemo(() => {
    if (!activeEmpId) return false;
    return !isOwnRequest(activeEmpId) && String(userEmp) !== String(activeEmpId);
  }, [activeEmpId, userEmp]);

  const allRowExpIds = useMemo(() => {
    return (expenseData || [])
      .filter((item) => !item?.hasOwnProperty("Type") && (item?.expenses?.ExpId || item?.ExpId))
      .map((item) => String(item?.expenses?.ExpId || item?.ExpId));
  }, [expenseData]);

  // When expenseData loads, select all valid expense rows by default ("select all default")
  useEffect(() => {
    if (expenseData && expenseData.length > 0) {
      const allIds = expenseData
        .filter((item) => !item?.hasOwnProperty("Type") && (item?.expenses?.ExpId || item?.ExpId))
        .map((item) => String(item?.expenses?.ExpId || item?.ExpId));
      setSelectedExpIds(allIds);
      setSelectAll(true);
      setExpIdList(allIds.join(","));
    } else {
      setSelectedExpIds([]);
      setSelectAll(false);
      setExpIdList("");
    }
  }, [expenseData]);

  const allSubmittableIds = useMemo(() => {
    return (expenseData || [])
      .filter((item) => {
        const isSummaryRow = Object.prototype.hasOwnProperty.call(item || {}, "Type");
        const expId = String(item?.expenses?.ExpId ?? item?.ExpId ?? "");
        if (isSummaryRow || !expId) return false;

        const rawStatus = item?.expenses?.ExpenseStatus ?? item?.ExpenseStatus;
        const status = statusMap?.[rawStatus] || statusMap?.[Number(rawStatus)];
        return (
          Number(rawStatus) === 1 ||
          Number(rawStatus) === 4 ||
          status === "Created" ||
          status === "Rejected"
        );
      })
      .map((item) => String(item?.expenses?.ExpId ?? item?.ExpId));
  }, [expenseData, statusMap]);

  const allCheckboxesSelected = useMemo(() => {
    return selectAll && allRowExpIds.length > 0 && selectedExpIds.length === allRowExpIds.length;
  }, [selectAll, allRowExpIds.length, selectedExpIds.length]);

  const selectableExpenseIds = useMemo(() => {
    return allSubmittableIds.filter((id) => selectedExpIds.includes(id));
  }, [allSubmittableIds, selectedExpIds]);

  const approvableExpenseIds = useMemo(() => {
    return (expenseData || [])
      .filter((item) => {
        const isSummaryRow = Object.prototype.hasOwnProperty.call(item || {}, "Type");
        const expId = String(item?.expenses?.ExpId ?? item?.ExpId ?? "");
        if (isSummaryRow || !expId) return false;

        const rawStatus = item?.expenses?.ExpenseStatus ?? item?.ExpenseStatus;
        return Number(rawStatus) === 2 && selectedExpIds.includes(expId);
      })
      .map((item) => String(item?.expenses?.ExpId ?? item?.ExpId));
  }, [expenseData, selectedExpIds]);

  const actualExpCount = useMemo(() => {
    if (totalExpCount > 0) return totalExpCount;
    return (expenseData || []).filter(
      (item) => !item?.hasOwnProperty("Type") && (item?.expenses?.ExpId || item?.ExpId)
    ).length;
  }, [totalExpCount, expenseData]);

  const actualWorkingDays = Number(workingDays || 0);

  // If submittable expenses exist and total expense count is less than working days -> Some dates are pending for attendance!
  const showPendingAttendanceWarning = useMemo(() => {
    return allSubmittableIds.length > 0 && actualWorkingDays > 0 && actualExpCount < actualWorkingDays;
  }, [allSubmittableIds.length, actualWorkingDays, actualExpCount]);

  // Can submit expenses only after all checkboxes are selected and attendance count >= working days
  const canSubmitExpenses = useMemo(() => {
    return (
      allSubmittableIds.length > 0 &&
      allCheckboxesSelected &&
      (actualWorkingDays === 0 || actualExpCount >= actualWorkingDays)
    );
  }, [allSubmittableIds.length, allCheckboxesSelected, actualWorkingDays, actualExpCount]);

  useEffect(() => {
    const fetchExpenses = async () => {
      try {
        setLoading(true); // Set loading to true before fetching data
        const url = `${serverUrl}${API.getExpensesNew}`;
        const params = {
          month: selectedMonthStr,
          employee: activeEmpId,
        };
        const { status, data } = await postData(url, true, params);

        if (status === 200) {
          const formattedData = Object.entries(data.data.data).map(
            ([key, value]: [string, any]) => ({
              date: key, // Use the key as the date
              ...value,
            })
          );
          setExpenseData(formattedData);
          setTotalExpCount(data?.data?.expensecount);
          // compute total expense amount from the response
          try {
            const total = formattedData.reduce((acc, item) => {
              // Prefer explicit total field
              if (item?.expenses?.ExpenseFinalAmt != null) {
                const v = Number(item.expenses.ExpenseFinalAmt) || 0;
                return acc + v;
              }
              if (item?.TotalExpenseAmount != null) {
                const v = Number(item.TotalExpenseAmount) || 0;
                return acc + v;
              }
              // Fall back to summing expenseLine amounts
              if (
                Array.isArray(item.expenseLine) &&
                item.expenseLine.length > 0
              ) {
                const sumLine = item.expenseLine.reduce(
                  (s: number, line: any) =>
                    s + (Number(line.ExpFinalAmount) || 0),
                  0
                );
                return acc + sumLine;
              }
              return acc;
            }, 0);
            setTotalExpenseAmountFromApi(total);
          } catch (err) {
            console.error("Error computing total expense amount:", err);
            setTotalExpenseAmountFromApi(0);
          }
          console.log("Formatted Expenses:data", data.data);
        } else {
          console.error("Failed to fetch expenses.");
        }
      } catch (error) {
        console.error("Error fetching expenses:", error);
      } finally {
        setLoading(false); // Set loading to false after fetching data
      }
    };

    const fetchStatusMap = async () => {
      try {
        const url = `${serverUrl}${API.getStatus}`;
        // console.log('Fetching Status Map from:', url); // Log the URL
        const { status, data } = await getData(url, true);
        // console.log('Raw Response:', { status, data }); // Log the raw response

        if (status === 200 && data.data[0]?.Expenses) {
          const parsedStatusMap = Object.keys(data.data[0].Expenses).reduce(
            (acc, key) => {
              acc[parseInt(key, 10)] = data.data[0].Expenses[key];
              return acc;
            },
            {} as Record<number, string>
          );
          setStatusMap(parsedStatusMap);
          // console.log('Fetched Status Map:', parsedStatusMap); // Log the status map
        } else {
          console.error(
            "Failed to fetch status map. Status:",
            status,
            "Data:",
            data
          );
        }
      } catch (error) {
        console.error("Error fetching status map:", error);
      }
    };

    fetchExpenses();
    fetchStatusMap();
  }, [selectedMonthStr, activeEmpId, serverUrl, refreshKey]);

  useEffect(() => {
    const lengthOfToBeVerifiedExp = expenseData?.filter(
      (item) =>
        item?.expenses?.DoVerify === true &&
        !varifiedExpenses[item?.expenses?.ExpId]?.includes(
          item?.expenses?.ExpenseDate
        )
    );
    setToBeVerifiedExpenses(lengthOfToBeVerifiedExp);
    console.log("To be verified expenses:", lengthOfToBeVerifiedExp);
  }, [expenseData, varifiedExpenses]);

  const toggleSelectAll = (checked: boolean) => {
    if (checked) {
      setSelectedExpIds(allRowExpIds);
      setSelectAll(true);
      setExpIdList(allRowExpIds.join(","));
    } else {
      setSelectedExpIds([]);
      setSelectAll(false);
      setExpIdList("");
    }
  };

  const handleCheckboxToggle = () => {
    // "cant diselect one one select mean select all": clicking any checkbox toggles all checkboxes together
    toggleSelectAll(!selectAll);
  };

  useEffect(() => {
    if (expenseData.length > 0) {
      addToVarifiedExpenses();
    }
  }, [expenseData]);

  const headData = [
    {
      id: "select",
      head: (
        <input
          type="checkbox"
          checked={selectAll}
          onChange={(event) => toggleSelectAll(event.target.checked)}
        />
      ),
      key: "select",
    },
    { id: "date", head: "Expense Date", key: "date", sortKey: "date" },
    {
      id: "totalCalls",
      head: "Total Calls",
      key: "TotalCalls",
      sortKey: "TotalCalls",
    },
    { id: "totalNCAs", head: `Total ${getLabel('NCA')}'s`, key: "NCA", sortKey: "NCA" },
    {
      id: "type",
      head: "Type",
      key: "expenses.TripType",
      sortKey: "expenses.TripType",
    },
    {
      id: "placeOfWork",
      head: "Place Of Work",
      key: "expenses.ExpensePlacewrk",
      sortKey: "expenses.ExpensePlacewrk",
    },
    { id: "ta", head: "TA", key: "ta", sortKey: "ta" },
    { id: "da", head: "DA", key: "da", sortKey: "da" },
    {
      id: "otherExpense",
      head: "Other Expense",
      key: "otherExpense",
      sortKey: "otherExpense",
    },
    {
      id: "totalExpense",
      head: "Total Expense",
      key: "expenses.ExpenseFinalAmt",
      sortKey: "expenses.ExpenseFinalAmt",
    },
    {
      id: "status",
      head: "Status",
      key: "expenses.ExpenseStatus",
      sortKey: "expenses.ExpenseStatus",
    },
  ];

  const handleViewClick = (
    item: any,
    index: number
  ) => {
    const selectedExpId = item?.expenses?.ExpId;
    if (!selectedExpId) return;

    const validExpenseList = expenseData.filter((i) => i?.expenses?.ExpId);
    const validIndex = validExpenseList.findIndex(
      (i) => i?.expenses?.ExpId === selectedExpId
    );
    const isOwn = isOwnRequest(employeeId);

    navigate("/expenses/expenseoverview", {
      state: {
        expId: selectedExpId,
        doVerify: item?.expenses?.DoVerify,
        expenseStatus: item?.expenses?.ExpenseStatus,
        expenseList: validExpenseList,
        currentIndex: validIndex >= 0 ? validIndex : 0,
        isOwnUser: isOwn,
        manager: !isOwn,
      },
    });
  };

  const renderRow = (item: any, index: number) => {
    const ta =
      item.expenseLine?.find((line: any) =>
        line.ExpenseMaster?.ExpenseName?.toLowerCase().includes("ta")
      )?.ExpFinalAmount || 0;
    const da =
      item.expenseLine?.find((line: any) =>
        line.ExpenseMaster?.ExpenseName?.toLowerCase().includes("da")
      )?.ExpFinalAmount || 0;
    const otherExpense = item.expenses?.ExpenseFinalAmt - (ta + da);
    let type = item?.hasOwnProperty("Type");
    let shouldValidated =
      item?.expenses?.DoVerify &&
      !varifiedExpenses.hasOwnProperty(item.expenses.ExpId);
    const expenseStatus = Number(item.expenses?.ExpenseStatus);
    const status = statusMap[expenseStatus] || "-";

    const statusColors: Record<number, string> = {
      1: "#ff8400ff",
      2: "#1c65d3",
      3: "#6cbb33ff",
      4: "#ff0000ff",
      5: "#ffa500ff",
      6: "#800080ff",
      7: "#a52a2aff",
      8: "#008080ff",
      9: "#f96c6cff",
      10: "#0400ffff",
      11: "#009400ff",
    };

    const statusColor = statusColors[expenseStatus] || "black";

    const getRowColor = (item: any) => {
      if (item?.expenses?.DoVerify && item?.FW < 4) {
        return "#F8EA8C";
      }
      if (item?.expenses?.DoVerify) {
        return "#F8EA8C";
      }
      if (item?.WeekOff || item?.Holiday || item?.Leave) {
        return "#ADD8E6";
      }
      if (item?.FW < 4 || (item?.NCA > 0 && item?.FW > 0)) {
        return "#F9BDC0";
      }
      return "white";
    };

    const expId = String(item?.expenses?.ExpId ?? item?.ExpId ?? "");
    const isChecked = expId ? selectedExpIds.includes(expId) : false;

    return (
      <tr key={index} style={{ backgroundColor: getRowColor(item) }}>
        <td style={{ paddingLeft: 10 }}>
          {!type && expId ? (
            <input
              type="checkbox"
              checked={selectAll}
              onChange={handleCheckboxToggle}
            />
          ) : null}
        </td>
        <td style={{ paddingLeft: 10 }}>
          {moment(item.date, "YYYY-MM-DD").format("DD MMM")}
        </td>
        <td style={{ paddingLeft: 10 }}>{item.TotalCalls || "-"}</td>
        <td style={{ paddingLeft: 10 }}>{item.NCA || "-"}</td>
        <td style={{ paddingLeft: 10 }}>{item.expenses?.TripType || "-"}</td>
        <td style={{ paddingLeft: 10 }}>
          {item.expenses?.ExpensePlacewrk || "-"}
        </td>
        <td style={{ paddingLeft: 10 }}>{ta}</td>
        <td style={{ paddingLeft: 10 }}>{da}</td>
        <td style={{ paddingLeft: 10 }}>{otherExpense || "-"}</td>
        <td style={{ paddingLeft: 10 }}>
          {item.expenses?.ExpenseFinalAmt || "-"}
        </td>
        <td style={{ paddingLeft: 10, color: statusColor }}>
          {!type ? status : item.Day || "-"}
        </td>
        <td style={{ paddingLeft: 10 }}>
          {!type && item?.expenses?.ExpId ? (
            <button
              className="btn btn-primary btn-sm"
              onClick={() => handleViewClick(item, index)}
            >
              View
            </button>
          ) : null}
        </td>
      </tr>
    );
  };

  const addToVarifiedExpenses = () => {
    const newVarifiedExpenses: Record<string, string[]> = {};
    expenseData.forEach((item) => {
      if (item?.expenses?.ExpId && item?.expenses?.ExpenseDate) {
        newVarifiedExpenses[item.expenses.ExpId] = [item.expenses.ExpenseDate];
      }
    });
    setVarifiedExpenses((prev) => ({
      ...prev,
      ...newVarifiedExpenses,
    }));
    console.log("Varified Expenses Updated:", newVarifiedExpenses);
  };

  const fetchWorkingDays = async () => {
    try {
      const url = `${serverUrl}${API.getWorkingDays}`;
      const rawDate = selectedMonthStr.split("|")[0];
      let mDate = moment(rawDate, "YYYY-MM-DD");
      if (!mDate.isValid()) {
        mDate = moment(rawDate, "MM-YYYY");
      }
      const formattedMonth = mDate.isValid() ? mDate.format("MM-YYYY") : "";
      const params = { employee_id: activeEmpId, month: formattedMonth };
      const { status, data } = await getData(url, true, params);
      console.log("Fetched Working Days:", data);
      if (status === 200) {
        setWorkingDays(data?.data?.WorkingDays ?? 0);
      } else {
        console.error("Failed to fetch working days.");
      }
    } catch (error) {
      console.error("Error fetching working days:", error);
    }
  };

  useEffect(() => {
    if (activeEmpId && selectedMonthStr) {
      fetchWorkingDays();
    }
  }, [activeEmpId, selectedMonthStr, refreshKey]);

  const handleSubmitButtonClick = () => {
    if (!allCheckboxesSelected) {
      toast.warning("Please select all checkboxes to submit expenses.");
      return;
    }
    if (actualWorkingDays > 0 && actualExpCount < actualWorkingDays) {
      toast.warning("Some dates are pending for attendance. Please complete attendance before submitting.");
      return;
    }
    setSubmitConfirmationVisible(true);
  };

  const submitExpenseAction = async (status: number, note: string = "") => {
    const targetIds = selectableExpenseIds.length > 0 ? selectableExpenseIds : allSubmittableIds;
    if (targetIds.length === 0) {
      toast.warning("No expenses available to submit.");
      return;
    }
    setIsSubmitting(true);
    try {
      const url = `${serverUrl}${API.expensesApproved}`;
      const params = {
        ExpId: targetIds,
        status,
        note,
      };
      const { status: respStatus, data } = await postData(url, true, params);
      if (respStatus === 200) {
        toast.success(data?.message || "Expenses submitted successfully!");
        setSubmitConfirmationVisible(false);
        setSubmitRemarkModalVisible(false);
        setSubmitRemark("");
        setRefreshKey((prev) => !prev);
      } else {
        toast.warning(data?.message || "Failed to submit expenses.");
      }
    } catch (error) {
      console.error("Error submitting expense:", error);
      toast.error("An error occurred while submitting expenses.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const submitExpense = async (action: number, rejectionNote: string = "") => {
    const targetIds =
      action === 3
        ? (approvableExpenseIds.length > 0 ? approvableExpenseIds : selectedExpIds)
        : (selectableExpenseIds.length > 0 ? selectableExpenseIds : allSubmittableIds);
    if (targetIds.length === 0) {
      toast.warning("No expenses selected.");
      return;
    }
    try {
      const url = `${serverUrl}${API.expensesApproved}`;
      const params = {
        ExpId: targetIds,
        status: action,
        note: action === 4 ? rejectionNote : (action === 2 ? rejectionNote : ""),
      };
      const { status, data } = await postData(url, true, params);
      console.log("Response:", data);
      if (status === 200) {
        toast.success(data.message || (action === 3 ? "Expenses approved successfully!" : "Expense submitted successfully!"));
        setRefreshKey((prev) => !prev);
      } else {
        toast.error(data.message || "Failed to submit expense.");
      }
    } catch (error) {
      console.error("Error submitting expense:", error);
      toast.error("An error occurred while submitting the expense.");
    }
  };

  useEffect(() => {
    const fetchLastDates = async () => {
      try {
        const url = `${serverUrl}${API.getExpenseLastDates}`;
        const params = { employee_id: activeEmpId, month: selectedMonthStr };
        const { status, data } = await getData(url, true, params);

        if (status === 200) {
          console.log("Fetched Last Dates:", data);
          setLastDates(data.data);
        } else {
          console.error("Failed to fetch last dates.");
        }
      } catch (error) {
        console.error("Error fetching last dates:", error);
      }
    };

    if (activeEmpId && selectedMonthStr) {
      fetchLastDates();
    }
  }, [activeEmpId, selectedMonthStr, refreshKey]);

  return (
    <div style={{ padding: "20px" }} className="page-body p-2">
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <CardHeaderSpan
          headingClassName="p-2"
          back={true}
          backPath={backPath ?? "/Approvals"}
          backState={backState ?? { activeTab: "3" }}
          heading={`Expense of ${dropdownLabel} `}
          span={"ReportListTitle"}
        />
        <div className="d-flex align-items-center">
          {!showPendingAttendanceWarning && allSubmittableIds.length > 0 && (
            <Button
              color="success"
              className="d-flex align-items-center me-2 text-white fw-bold shadow-sm"
              style={{
                backgroundColor: canSubmitExpenses ? "#28a745" : "#94a3b8",
                borderColor: canSubmitExpenses ? "#28a745" : "#94a3b8",
                cursor: canSubmitExpenses ? "pointer" : "not-allowed",
              }}
              title={
                !allCheckboxesSelected
                  ? "All checkboxes must be selected to submit"
                  : "Submit all expenses"
              }
              onClick={handleSubmitButtonClick}
            >
              <i className="fa fa-check me-2"></i>
              Submit All Expenses
            </Button>
          )}
          {actualExpCount >= (workingDays || 0) &&
            toBeVerifiedExpenses.length < 1 &&
            approvableExpenseIds.length > 0 && (
              <button
                className="btn btn-primary"
                style={{ marginRight: "10px" }}
                onClick={() => submitExpense(3, "")}
              >
                Approve
              </button>
            )}
        </div>
      </div>

      <div className="row g-2">
        <div className="col-lg-2 col-md-6 col-sm-12">
          <Card
            style={{
              minHeight: "90px",
              border: "1px solid #ddd",
              backgroundColor: "#fff",
            }}
          >
            <CardBody
              style={{
                padding: "12px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h6
                  style={{
                    fontSize: "0.9rem",
                    color: "#888",
                    marginBottom: "4px",
                  }}
                >
                  Total Expenses
                </h6>
                <h3 style={{ fontSize: "1rem", margin: 0, fontWeight: 600 }}>
                  ₹ {totalExpenseAmountFromApi || totalExpenseAmount || "0"}
                </h3>
              </div>
            </CardBody>
          </Card>
        </div>

        <div className="col-lg-2 col-md-6 col-sm-12">
          <Card
            style={{
              minHeight: "90px",
              border: "1px solid #ddd",
              backgroundColor: "#fff",
            }}
          >
            <CardBody
              style={{
                padding: "12px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div>
                <h6
                  style={{
                    fontSize: "0.9rem",
                    color: "#888",
                    marginBottom: "4px",
                  }}
                >
                  Working Days
                </h6>
                <h3 style={{ fontSize: "1rem", margin: 0, fontWeight: 600 }}>
                  {workingDays || "-"}
                </h3>
              </div>
            </CardBody>
          </Card>
        </div>

        {/* Last Dates Cards */}
        {(
          ["LastSubmittedDate", "LastApprovedDate", "LastAuditedDate"] as Array<
            keyof typeof lastDates
          >
        ).map(
          (key) =>
            lastDates[key] && (
              <div className="col-lg-2 col-md-6 col-sm-12" key={key}>
                <Card
                  style={{
                    minHeight: "90px",
                    border: "1px solid #ddd",
                    backgroundColor: "#fff",
                  }}
                >
                  <CardBody
                    style={{
                      padding: "12px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <h6
                        style={{
                          fontSize: "0.9rem",
                          color: "#888",
                          marginBottom: "4px",
                        }}
                      >
                        {key.replace("Last", "").replace("Date", "")}
                      </h6>
                      <h3
                        style={{
                          fontSize: "1rem",
                          margin: 0,
                          fontWeight: 600,
                        }}
                      >
                        {moment(lastDates[key]).format("DD MMM YYYY")}
                      </h3>
                    </div>
                  </CardBody>
                </Card>
              </div>
            )
        )}
      </div>

      {/* Warning banner above table if dates pending for attendance */}
      {showPendingAttendanceWarning && (
        <div
          className="d-flex align-items-center justify-content-center py-2 px-3 my-3 text-white fw-bold rounded shadow-sm"
          style={{ backgroundColor: "#f97316", fontSize: "16px" }}
        >
          <i className="fa fa-exclamation-triangle me-2 fs-5"></i>
          Some dates are pending for attendance.
        </div>
      )}

      {/* Confirmation Modal */}
      <Modal
        isOpen={submitConfirmationVisible}
        toggle={() => setSubmitConfirmationVisible(false)}
        centered
      >
        <ModalHeader toggle={() => setSubmitConfirmationVisible(false)}>
          Submit Expenses
        </ModalHeader>
        <ModalBody>
          Are you sure you want to submit all the selected expenses?
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setSubmitConfirmationVisible(false)}
          >
            Cancel
          </Button>{" "}
          <Button
            color="success"
            onClick={() => {
              setSubmitConfirmationVisible(false);
              setSubmitRemarkModalVisible(true);
            }}
          >
            Confirm
          </Button>
        </ModalFooter>
      </Modal>

      {/* Remark Modal */}
      <Modal
        isOpen={submitRemarkModalVisible}
        toggle={() => setSubmitRemarkModalVisible(false)}
        centered
      >
        <ModalHeader toggle={() => setSubmitRemarkModalVisible(false)}>
          Submit Expenses
        </ModalHeader>
        <ModalBody>
          <div className="mb-2">
            <label className="form-label fw-semibold text-dark">Remark</label>
            <Input
              type="textarea"
              rows={3}
              placeholder="Enter remark"
              value={submitRemark}
              onChange={(e) => setSubmitRemark(e.target.value)}
            />
            <small className="d-block mt-2" style={{ color: "#f97316" }}>
              Note: Remark is not mandatory.
            </small>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setSubmitRemarkModalVisible(false)}
          >
            Cancel
          </Button>{" "}
          <Button
            color="primary"
            disabled={isSubmitting}
            onClick={() => submitExpenseAction(2, submitRemark)}
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </ModalFooter>
      </Modal>

      {loading ? (
        <div className="text-center py-3">
          <div>
            <Image
              className="b-r-10 img-80"
              src={dynamicImage("dashboard/loader.gif")}
              alt="Loading..."
            />
          </div>
        </div>
      ) : (
        <div className="px-2">
          <CommonTableNew
            tableClass="table caption"
            strip={false}
            caption=""
            size="sm"
            hover
            headData={headData}
            data={expenseData}
            renderRow={renderRow}
            initialRows={35} // Show 35 rows initially
          />

          {/* Bottom Action Area matching mobile apk */}
          {canSubmitExpenses ? (
            <div className="mt-3 w-100 d-flex justify-content-center">
              <Button
                color="success"
                className="w-100 py-2 fw-bold text-white shadow-sm d-flex align-items-center justify-content-center"
                style={{ backgroundColor: "#28a745", borderColor: "#28a745", fontSize: "16px" }}
                onClick={() => setSubmitConfirmationVisible(true)}
              >
                <i className="fa fa-check me-2"></i>
                Submit All Expenses
              </Button>
            </div>
          ) : (
            showPendingAttendanceWarning && (
              <div
                className="d-flex align-items-center justify-content-center py-2 px-3 my-3 text-white fw-bold rounded shadow-sm"
                style={{ backgroundColor: "#f97316", fontSize: "16px" }}
              >
                <i className="fa fa-exclamation-triangle me-2 fs-5"></i>
                Some dates are pending for attendance.
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
};

export default Expenses;
